import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";

function isEmpty(value) {
  return value === undefined || value === null || typeof value === 'object' && _Object$keys(value).length === 0 || typeof value === 'string' && value.trim().length === 0;
}

export var validateAxiosResponse = function validateAxiosResponse() {
  var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return res && res.ok && 'data' in res && !isEmpty(res.data);
};
export default {};